import { UserList } from "./UserList";
import { UserShow } from "./UserShow";

export default {
  list: UserList,
  show: UserShow,
};
